<section class="ai-task-block">
  <div class="ai-task-table-wrap">
    <table class="ai-task-table">
      <thead>
        <tr>
          <th class="ai-th-task">
            Task Name
            <span class="ai-th-count">{{ block.tasks.length }}</span>
          </th>
          <th class="ai-hide-col">Due Date</th>
          <th class="ai-th-center ai-hide-col">Assigned To</th>
          <th class="ai-th-center ai-hide-col">Progress</th>
          <th class="ai-th-center ai-hide-col">Status</th>
          <th class="ai-th-center ai-hide-col">Priority</th>
          <th class="ai-th-center ai-hide-col">Risk</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let task of block.tasks">

          <!-- ── Main row ── -->
          <tr class="ai-task-row" (click)="openTask(task)" tabindex="0" (keydown.enter)="openTask(task)">

            <!-- Task Name -->
            <td class="ai-td-task">
              <div class="ai-task-name-wrap">
                <button
                  class="ai-chevron-btn"
                  (click)="toggleExpand(task.taskId, $event)"
                  [title]="isExpanded(task.taskId) ? 'Collapse' : 'Expand'"
                >
                  <svg class="ai-chevron" [class.open]="isExpanded(task.taskId)"
                       width="14" height="14" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.7"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="ai-task-info">
                  <span class="ai-task-id">{{ task.taskId }}</span>
                  <div class="ai-task-title-row">
                    <span class="ai-task-title">{{ task.title }}</span>
                    <!-- Badges shown inline only in responsive (narrow) view -->
                    <div class="ai-inline-badges">
                      <span class="ai-pill" [ngClass]="badgeClass(task.status)">{{ task.status }}</span>
                      <span class="ai-pill" [ngClass]="badgeClass(task.priority)">{{ task.priority }}</span>
                      <span class="ai-pill" [ngClass]="badgeClass(task.risk)">{{ task.risk }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>

           

            <!-- Due Date -->
            <td class="ai-td-date ai-hide-col">
              <ng-container *ngIf="task.dueDate; else noDate">
                <div class="ai-date-line">{{ formatDueDate(task.dueDate) }}</div>
                <div class="ai-due-relative" [ngClass]="getDueDateClass(task.dueDate)">
                  {{ getDueDateRelative(task.dueDate) }}
                </div>
              </ng-container>
              <ng-template #noDate><span class="ai-empty">—</span></ng-template>
            </td>

            <!-- Assigned To -->
            <td class="ai-td-center ai-hide-col">
              <ng-container *ngIf="task.assignedTo; else noAssignee">
                <img *ngIf="task.assignedToAvatar; else initials"
                     [src]="task.assignedToAvatar"
                     [alt]="task.assignedTo"
                     class="ai-avatar ai-avatar--img" />
                <ng-template #initials>
                  <div class="ai-avatar ai-avatar--initials" [title]="task.assignedTo">
                    {{ getInitials(task.assignedTo) }}
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #noAssignee><span class="ai-empty">—</span></ng-template>
            </td>

            <!-- Progress -->
            <td class="ai-td-center ai-hide-col">
              <div class="ai-progress-wrap">
                <div class="ai-progress-track">
                  <div class="ai-progress-fill"
                       [style.width.%]="task.progress ?? 0"
                       [style.background]="getProgressColor(task.progress ?? 0)"></div>
                </div>
                <span class="ai-pct" [style.color]="getProgressColor(task.progress ?? 0)">
                  {{ task.progress ?? 0 }}%
                </span>
              </div>
            </td>

            <!-- Status -->
            <td class="ai-td-center ai-hide-col">
              <span class="ai-pill" [ngClass]="badgeClass(task.status)">{{ task.status }}</span>
            </td>

            <!-- Priority -->
            <td class="ai-td-center ai-hide-col">
              <span class="ai-pill" [ngClass]="badgeClass(task.priority)">{{ task.priority }}</span>
            </td>

            <!-- Risk -->
            <td class="ai-td-center ai-hide-col">
              <span class="ai-pill" [ngClass]="badgeClass(task.risk)">{{ task.risk }}</span>
            </td>
          </tr>

          <!-- ── Expand row ── -->
          <tr *ngIf="isExpanded(task.taskId)" class="ai-expand-row">
            <td colspan="8" class="ai-expand-td">
              <div class="ai-expand-content">
                <div class="ai-expand-grid">

                  <!-- Left: Description + domain -->
                  <div class="ai-expand-left">
                    <span class="ai-expand-label">Description</span>
                    <p class="ai-expand-desc">
                      {{ task.description || 'No description available.' }}
                    </p>
                    <div class="ai-expand-domain" *ngIf="task.domain">
                      <!-- <span class="ai-domain-badge">{{ getDomainInitials(task.domain) }}</span> -->
                      <!-- <span class="ai-expand-domain-name">{{ task.domain }}</span> -->
                    </div>

                    <!-- Responsive: fields shown only when columns are hidden -->
                    <div class="ai-responsive-fields">
                      <div class="ai-expand-row-fields">

                        <!-- Row 1: Due Date | Actionables | Assigned To | Progress -->
                        <div class="ai-expand-fields-row">
                          <div class="ai-expand-field" *ngIf="task.dueDate">
                            <span class="ai-expand-label">Due Date</span>
                            <div class="ai-date-line">{{ formatDueDate(task.dueDate) }}</div>
                            <div class="ai-due-relative" [ngClass]="getDueDateClass(task.dueDate)">
                              {{ getDueDateRelative(task.dueDate) }}
                            </div>
                          </div>
                          <!-- <div class="ai-expand-field">
                            <span class="ai-expand-label">Actionables / Frameworks</span>
                            <div class="ai-expand-count">
                              <span class="ai-count-val">{{ task.actionItems?.total ?? 0 }}</span>
                              <span class="ai-count-sep"> / </span>
                              <span class="ai-count-val">{{ task.frameworks?.total ?? 0 }}</span>
                            </div>
                          </div> -->
                          <div class="ai-expand-field">
                            <span class="ai-expand-label">Assigned To</span>
                            <ng-container *ngIf="task.assignedTo; else noAssigneeExp">
                              <img *ngIf="task.assignedToAvatar; else initialsExp"
                                   [src]="task.assignedToAvatar"
                                   [alt]="task.assignedTo"
                                   class="ai-avatar ai-avatar--img" />
                              <ng-template #initialsExp>
                                <div class="ai-avatar ai-avatar--initials" [title]="task.assignedTo">
                                  {{ getInitials(task.assignedTo) }}
                                </div>
                              </ng-template>
                            </ng-container>
                            <ng-template #noAssigneeExp><span class="ai-empty">—</span></ng-template>
                          </div>
                          <div class="ai-expand-field">
                            <span class="ai-expand-label">Progress</span>
                            <div class="ai-progress-wrap ai-progress-wrap--expand">
                              <div class="ai-progress-track">
                                <div class="ai-progress-fill"
                                     [style.width.%]="task.progress ?? 0"
                                     [style.background]="getProgressColor(task.progress ?? 0)"></div>
                              </div>
                              <span class="ai-pct" [style.color]="getProgressColor(task.progress ?? 0)">
                                {{ task.progress ?? 0 }}%
                              </span>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>

                  <!-- Right: Mapped Standards / Frameworks chips -->
                  <div class="ai-expand-right" *ngIf="task.frameworks?.ids?.length">
                    <span class="ai-expand-label">Frameworks</span>
                    <div class="ai-expand-chips">
                      <span class="ai-chip" *ngFor="let fw of (task.frameworks!.ids | slice:0:5)">{{ fw }}</span>
                      <span class="ai-chip ai-chip--more" *ngIf="task.frameworks!.total > 5">
                        +{{ task.frameworks!.total - 5 }}
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </td>
          </tr>

        </ng-container>
      </tbody>
    </table>
  </div>

  <button type="button" class="ai-view-all">
    View all
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M3 8h10M9 4l4 4-4 4"/>
    </svg>
  </button>
</section>
